import React, { useRef } from 'react';
import styled from 'styled-components';

import { useModal } from '../../../Providers/ModalContext';
import Modal from '../../../Global/Modal';
import RichText from '../../../Global/RichText';

import CloseIcon from '../../../../Images/icons/close-icon.png';
import AiBg from '../../../../Images/background/bg_ai-services.png';
import LogoStudio from '../../../../Images/logos/logo-studio.png';

import ArtistAndres from '../../../../Images/gallery/ai-services/andres-b.png';
import ArtistAlvaro from '../../../../Images/gallery/ai-services/alvaro-c.png';
import ArtistDavidN from '../../../../Images/gallery/ai-services/david-n.png';
import ArtistMiguelTamara from '../../../../Images/gallery/ai-services/miguel-tamara.png';
import ArtistJJUnicorn from '../../../../Images/gallery/ai-services/jj-unicorn.png';

import {
  Ai_Title,
  First_Title,
  First_Text,
  Second_Title,
  Second_Text,
  Third_Title,
  Third_Text,
  Fourth_Title,
  Fourth_Text,
  Fifth_Title,
  Fifth_Text,
  Sixth_Title,
  Sixth_Text,
  Seventh_Title,
  Seventh_Text,
  Artist_Title,
  Artist_Text,
} from '../../../../utils/ES/Modals/aiServices';

const breakpoints = {
  mobile: '768px',
  tablet: '1024px',
  desktop: '1440px',
};

const CloseContainer = styled.div`
  padding: 10px;
  position: absolute;
  top: 30px;
  right: 30px;

  @media (max-width: ${breakpoints.mobile}) {
    top: 15px;
    right: 15px;
    width: 60px;
    height: 60px;
  }
`;

const CloseButton = styled.img`
  cursor: pointer;
  width: 64px;
  height: auto;
  transition: all 0.3s ease-out;
  transform-origin: center;

  @media (max-width: ${breakpoints.mobile}) {
    width: 40px;
  }

  &:hover {
    filter: drop-shadow(0px 0px 10px rgba(255, 255, 255, 1))
      drop-shadow(0px 0px 4px rgba(255, 255, 255, 1));
    transform: scale(1.15);
  }
`;

const ModalContent = styled.div`
  width: 100%;
  position: relative;
  padding: 25px 60px;
  display: flex;
  align-items: flex-start;

  flex-direction: column;
  gap: 4rem;
`;

const TitleContent = styled.div`
  display: flex;
  align-items: center;
  gap: 3.375rem;
  padding-right: 5%;

  p,
  h2,
  h3 {
    text-transform: uppercase;
  }
`;

const LogoContent = styled.div`
  display: block;
  max-width: 276px;
  width: 100%;
  padding: 15px;
  position: relative;

  img {
    display: block;
    width: 100%;
    cursor: pointer;
    transition: all 0.3s ease-out;

    &:hover {
      filter: drop-shadow(0px 0px 20px rgba(250, 115, 19, 1));
    }
  }

  &::after {
    content: '';
    position: absolute;
    width: 12px;
    height: 93px;
    background: #fff;

    top: 0;
    bottom: 0;

    margin: auto;
    right: -10%;
  }
`;

const AiTextContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 1.75rem;

  @media (max-width: ${breakpoints.tablet}) {
    flex-wrap: wrap;
    flex-direction: column;
    gap: 1.813rem;
  }
`;

const AiTextCol = styled.div`
  max-width: ${({ $maxWidth = '503px' }) => $maxWidth};
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 3.813rem;

  @media (max-width: ${breakpoints.tablet}) {
    gap: 1.813rem;
    max-width: 100%;
  }
`;

const AiTextItem = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 1.813rem;

  p {
    &:first-child {
      text-transform: uppercase;

      @media (max-width: ${breakpoints.mobile}) {
        font-size: 1.5rem;
      }
    }

    @media (max-width: ${breakpoints.mobile}) {
      font-size: 0.75rem;
    }
  }
`;

const AiArtistContainer = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 1.25rem;
`;

const AiArtistTitle = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.625rem;
  flex-direction: column;

  p {
    &:first-child {
      text-transform: uppercase;
      text-decoration: underline;

      @media (max-width: ${breakpoints.mobile}) {
        font-size: 1.75rem;
      }
    }

    @media (max-width: ${breakpoints.mobile}) {
      font-size: 1.25rem;
    }
  }
`;

const AiArtistGallery = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 2.313rem;

  @media (max-width: ${breakpoints.desktop}) {
    flex-wrap: wrap;
    gap: 1.5rem;
  }

  @media (max-width: ${breakpoints.mobile}) {
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 1.5rem;
  }
`;

const AiArtistItem = styled.img`
  max-width: 271px;
  width: 100%;
  height: auto;
  display: flex;
  transform-origin: center;
  cursor: pointer;
  transition: all 0.3s ease-out;

  &:hover {
    transform: scale(1.1);
  }

  @media (max-width: ${breakpoints.desktop}) {
    max-width: 18%;
  }

  @media (max-width: ${breakpoints.tablet}) {
    max-width: 30%;
  }

  @media (max-width: ${breakpoints.mobile}) {
    max-width: 45%;
  }
`;

const VideoFrame = styled.iframe`
  width: 100%;
  max-width: 100%;
  height: 594px;
  border: none;

  @media (max-width: ${breakpoints.mobile}) {
    height: 150px;
  }
`;

const ModalAiServices = () => {
  const { closeModal } = useModal();

  const { openModal } = useModal();

  const iframeRef = useRef(null);

  const handleClick = (e) => {
    const target = e.currentTarget.dataset.target;
    openModal(target);
  };

  return (
    <>
      <Modal id="ai-services" bgImg={AiBg}>
        <CloseContainer>
          <CloseButton
            onClick={closeModal}
            aria-label="Close modal"
            src={CloseIcon}
          />
        </CloseContainer>
        <ModalContent>
          <TitleContent>
            <LogoContent>
              <img
                src={LogoStudio}
                onClick={closeModal}
                aria-label="Close modal"
                alt="Kuter Studio"
              />
            </LogoContent>
            <RichText dataText={Ai_Title} />
          </TitleContent>
          <VideoFrame
            ref={iframeRef}
            src="https://player.vimeo.com/video/1163699447?h=8756b48cc5&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            allow="autoplay; fullscreen;"
            referrerPolicy="strict-origin-when-cross-origin"
            title="KUTER_AI_REEL"
          />
          <AiTextContainer>
            <AiTextCol>
              <AiTextItem>
                <RichText dataText={First_Title} />
                <RichText dataText={First_Text} />
              </AiTextItem>
              <AiTextItem>
                <RichText dataText={Second_Title} />
                <RichText dataText={Second_Text} />
              </AiTextItem>
              <AiTextItem>
                <RichText dataText={Third_Title} />
                <RichText dataText={Third_Text} />
              </AiTextItem>
            </AiTextCol>

            <AiTextCol $maxWidth={'499px'}>
              <AiTextItem>
                <RichText dataText={Fourth_Title} />
                <RichText dataText={Fourth_Text} />
              </AiTextItem>
              <AiTextItem>
                <RichText dataText={Fifth_Title} />
                <RichText dataText={Fifth_Text} />
              </AiTextItem>
            </AiTextCol>

            <AiTextCol $maxWidth={'423px'}>
              <AiTextItem>
                <RichText dataText={Sixth_Title} />
                <RichText dataText={Sixth_Text} />
              </AiTextItem>
              <AiTextItem>
                <RichText dataText={Seventh_Title} />
                <RichText dataText={Seventh_Text} />
              </AiTextItem>
            </AiTextCol>
          </AiTextContainer>
          <AiArtistContainer>
            <AiArtistTitle>
              <RichText dataText={Artist_Title} />
              <RichText dataText={Artist_Text} />
            </AiArtistTitle>
            <AiArtistGallery>
              <AiArtistItem
                data-target="artist-andres-b"
                onClick={handleClick}
                src={ArtistAndres}
                alt="Andrés B"
              />
              <AiArtistItem
                data-target="artist-alvaro-c"
                onClick={handleClick}
                src={ArtistAlvaro}
                alt="Álvaro C"
              />
              <AiArtistItem
                data-target="artist-david-n"
                onClick={handleClick}
                src={ArtistDavidN}
                alt="David N"
              />
              <AiArtistItem
                data-target="artist-miguel-tamara"
                onClick={handleClick}
                src={ArtistMiguelTamara}
                alt="Tamara & Miguel"
              />
              <AiArtistItem
                data-target="artist-jj-unicorn"
                onClick={handleClick}
                src={ArtistJJUnicorn}
                alt="JJUnicorn"
              />
            </AiArtistGallery>
          </AiArtistContainer>
        </ModalContent>
      </Modal>
    </>
  );
};

export default ModalAiServices;
